import React, { useEffect, useRef, useState } from "react";
import { Check } from "lucide-react";
import "@/styles/step-cheer.css";

/** One step forward flashes a short green "done" line; jumps (draft restore, welcome back) and Back stay quiet. */
export function useStepCheer(step, lines) {
  const prev = useRef(step);
  const [cheer, setCheer] = useState(null);
  useEffect(() => {
    const was = prev.current;
    prev.current = step;
    if (step !== was + 1 || !lines[was]) { setCheer(null); return; }
    try { navigator.vibrate?.(12); } catch { /* not supported */ }
    setCheer({ text: lines[was], key: Date.now() });
    const t = setTimeout(() => setCheer(null), 2300);
    return () => clearTimeout(t);
  }, [step]);  // eslint-disable-line react-hooks/exhaustive-deps
  return cheer;
}

export function StepCheer({ cheer, at, testId = "step-cheer" }) {
  if (!cheer) return null;
  return (
    <div key={cheer.key} className="sc-cheer" style={at ? { top: at } : undefined} role="status" data-testid={testId}>
      <span className="sc-tick"><Check strokeWidth={3.2} /></span>{cheer.text}
    </div>
  );
}

export const DoneTick = ({ className = "" }) => (
  <span className={`sc-done ${className}`} aria-hidden="true"><Check strokeWidth={3.4} /></span>
);

/** The apply form's progress: finished steps sweep green and pin a tick at the end of their bar. */
export function StepBar({ steps, step, barRef, cheer }) {
  return (
    <div ref={barRef} className="relative mb-5 flex scroll-mt-4 items-center gap-1.5" data-testid="apply-progress">
      {steps.map((s, i) => {
        const done = i < step;
        return (
          <div key={s} className="min-w-0 flex-1" data-testid={`apply-progress-${i}`} data-state={done ? "done" : i === step ? "now" : "next"}>
            <div className="relative">
              <div className={`sc-track${done || i === step ? " is-on" : ""}`}>{done && <span className="sc-fill" />}</div>
              {done && <DoneTick className="sc-done-bar" />}
            </div>
            <div className={`mt-1.5 truncate text-[10.5px] font-medium transition-colors ${done ? "text-emerald-300" : i === step ? "text-white" : "text-slate-500"}`}>{s}</div>
          </div>
        );
      })}
      <StepCheer cheer={cheer} testId="apply-step-cheer" />
    </div>
  );
}
